<div mat-dialog-title>
    <h3 class="text-lg font-medium leading-6 text-gray-900">
      Creation of a Service Provider Company
    </h3>
</div>
<div mat-dialog-content>
    <app-entreprise-prestataire-create-form></app-entreprise-prestataire-create-form>
</div>